/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { ReactComponent as AppLogo } from '../../../assets/appLogo.svg';
import DrawerList from '../DrawerList';
import * as Constant from '../../../constants/actionTypes';
import styles from './styles';
import techConfig from '../../../techConfig';

const SideDrawer = ({ open: isOpen, toggleDrawer, redirect, route, classes, intl }) => {
  return (
    <SwipeableDrawer
      open={isOpen}
      onOpen={() => toggleDrawer(true)}
      onClose={() => toggleDrawer(false)}
    >
      <div className={classes.drawerHeadWrapper} role="contentinfo">
        <AppLogo alt="MDP Logo" style={{ width: 60, height: 60 }} />
        <h2 className={classes.drawerHeader}>
          {`${intl
            .formatMessage({ id: Constant.LABEL_APP_TITLE })
            .replace(Constant.APP_NAME, `${techConfig.choosePreferredAppName}`)}`}
        </h2>
      </div>
      <div onClick={() => toggleDrawer(false)}>
        <DrawerList redirect={redirect} route={route} toggleDrawer={d => toggleDrawer(d)} />
      </div>
    </SwipeableDrawer>
  );
};

SideDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  redirect: PropTypes.func.isRequired,
  route: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

export default memo(injectIntl(withStyles(styles)(SideDrawer)));
